/* eslint-disable no-tabs */
const IconReturnSvg = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.221 21.0005C19.76 21.0005 19.359 20.6855 19.249 20.2375C18.36 16.5885 15.229 13.9525 11.454 13.5535V14.6745C11.454 15.3805 11.035 16.0095 10.362 16.3145C9.63 16.6475 8.778 16.5275 8.185 16.0105L3.118 11.5865C2.726 11.2425 2.5 10.7555 2.5 10.2505C2.5 9.74547 2.726 9.25847 3.118 8.91447L8.185 4.49047C8.778 3.97347 9.63 3.85347 10.362 4.18647C11.035 4.49147 11.454 5.12047 11.454 5.82647V7.04447C17.078 7.53747 21.5 12.1505 21.5 17.7505C21.5 18.5605 21.397 19.3965 21.193 20.2365C21.084 20.6855 20.683 21.0005 20.221 21.0005Z"
        fill="#343C44"
      />
    </svg>
  )
}

export default IconReturnSvg
